import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { AuthContextProvider } from "./context/AuthContext";
import { DarkModeContextProvider } from "./context/darkModeContext";
import PreviewApp from "./preview/PreviewApp";
import { enableDemoData } from "./board/boardData";
import { demoFixtures } from "./board/demo/demoAgency";

// ?preview → Station Board Studio's live preview: the board renderer on sample
// data, no sign-in. Demo data is switched on before anything renders, so no
// widget ever subscribes to a real agency here.
const isPreview = new URLSearchParams(window.location.search).has("preview");

if (isPreview) {
  enableDemoData(demoFixtures());
  document.body.style.margin = "0";
  ReactDOM.render(<PreviewApp />, document.getElementById("root"));
} else {
  ReactDOM.render(
    <React.StrictMode>
      <DarkModeContextProvider>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </DarkModeContextProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}
